import { useFeatureFlag, useFeatureFlagsStatus } from "./useFeatureFlags"

const CONTENT_STUDIO_P1A_FLAG = "content_studio_p1a"
// Content Studio as a whole is behind Communication Hub (useComingSoonRoutes).
const COMMUNICATION_HUB_FLAG = "communication_hub"

/** Content Studio P1a (new Library and P2+ «Add creative») is on only when both flags are on. */
export function useContentStudioP1a(): boolean {
  const p1a = useFeatureFlag(CONTENT_STUDIO_P1A_FLAG)
  const communicationHub = useFeatureFlag(COMMUNICATION_HUB_FLAG)
  return p1a && communicationHub
}

/**
 * Whether both flags are known yet (see `useFeatureFlagsStatus`): a P1a-only route must wait for
 * `ready` before deciding, or a refresh would bounce while the flags load (MPE-1367).
 */
export function useContentStudioP1aStatus() {
  const p1aStatus = useFeatureFlagsStatus(CONTENT_STUDIO_P1A_FLAG)
  const communicationHubStatus = useFeatureFlagsStatus(COMMUNICATION_HUB_FLAG)
  const enabled = useContentStudioP1a()
  const ready = p1aStatus.ready && communicationHubStatus.ready

  return {
    ready,
    failed: !ready && (p1aStatus.failed || communicationHubStatus.failed),
    retry: p1aStatus.retry,
    enabled,
  }
}
